"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function LinuxMulticolorFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.323 0c2.529 0 2.39 2.672 2.37 4.107 0 .94.495 1.58 1.045 2.252a8.304 8.304 0 011.455 2.326c.329.785.37 1.661.118 2.474.092.039.177.09.253.154.182.192.299.439.331.702.03.22.108.432.228.619.279.23.456.56.495.92a.753.753 0 01-.43.575c-.496.282-1.174.494-1.594.99l-.084-.065.084.07c-.37.476-.912.789-1.51.87a1.262 1.262 0 01-1.262-.717.953.953 0 01-.079-.208c-.693.05-1.262-.134-1.756-.134-.688.04-1.119.208-1.51.208a1.139 1.139 0 01-.811.628 2.604 2.604 0 01-1.752-.321c-.58-.307-1.312-.277-1.856-.391a.852.852 0 01-.629-.386 1.267 1.267 0 01.07-.99 1.574 1.574 0 000-.653 1.203 1.203 0 01.054-.742.99.99 0 01.584-.456c.193-.046.374-.134.53-.257.143-.148.272-.376.445-.56l.07-.073a3.687 3.687 0 01.192-1.668A9.992 9.992 0 015.195 6.25a3.617 3.617 0 00.703-2.024c.04-.99-.707-3.959 2.118-4.211h.322L8.323 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M9.47 3.317c.004.17-.03.339-.098.495a1.06 1.06 0 01-.149.242l-.059-.03c-.138-.059-.252-.099-.341-.133a.732.732 0 00.144-.42.698.698 0 00-.04-.273.495.495 0 00-.124-.213.247.247 0 00-.352-.01.495.495 0 00-.143.198.866.866 0 00-.054.282.544.544 0 000 .159 1.811 1.811 0 00-.362-.134v-.148c-.005-.17.03-.34.1-.495a.93.93 0 01.286-.376.619.619 0 01.396-.144.653.653 0 01.391.134c.13.095.232.223.297.37.069.157.106.325.109.496zM7.303 3.322c.006.064.006.128 0 .193H7.25c-.09.036-.174.083-.252.138a.94.94 0 000-.168.99.99 0 00-.055-.223.495.495 0 00-.114-.163.178.178 0 00-.123-.05.183.183 0 00-.129.075.371.371 0 00-.08.178.628.628 0 000 .237.782.782 0 00.055.218.41.41 0 00.11.163h.024L6.576 4l-.089.064a.797.797 0 01-.183-.272 1.173 1.173 0 01-.104-.44c-.01-.151.008-.302.054-.446a.787.787 0 01.188-.337.42.42 0 01.282-.133h.025c.1 0 .195.037.267.104.1.082.179.187.228.307.05.153.07.314.06.475zM9.47 4.945a1.316 1.316 0 01-.697.495c-.172.08-.337.175-.495.282a1.311 1.311 0 01-.742.193.99.99 0 01-.584-.233c-.144-.109-.252-.232-.396-.322-.05-.024-.163-.103-.193-.123C6.3 6.419 5.512 7.904 5.131 8.76a5.468 5.468 0 00-.436 1.925c-.668-.935-.173-2.083.08-2.608.252-.524.346-.697.272-.648a6.725 6.725 0 00-.851 1.85c-.097.36-.097.74 0 1.1.13.397.406.73.772.935.456.264.86.61 1.192 1.02a.866.866 0 01.233.776.391.391 0 01-.213.223.812.812 0 01-.307.054l.183.238c.094.123.188.247.267.376a3.082 3.082 0 003.578-.218c.1-.294.17-.598.213-.905.01-.421.056-.84.139-1.252a1.164 1.164 0 01.534-.792.786.786 0 01.134-.06v-.089c.084-.549.569-.574 1.183-.307.613.268.811.495.712.817h.134c.119-.396-.134-.688-.827-1.024l-.108-.085a2.416 2.416 0 000-1.113 3.855 3.855 0 00-1.104-1.846c-.074 0-.064.06.084.203.361.337 1.158 1.54.728 2.657a1.079 1.079 0 00-.342-.044 7.228 7.228 0 00-.737-2.024A16.148 16.148 0 019.47 4.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    d: "M10.926 11.002h-.03a.925.925 0 00-.435.678 6.389 6.389 0 00-.134 1.207c-.066.43-.17.854-.307 1.267-.14.363-.154.762-.04 1.134a1.02 1.02 0 001.055.603 2.079 2.079 0 001.366-.796c.495-.58 1.222-.797 1.643-1.055.212-.123.326-.242.336-.4.01-.159-.099-.406-.43-.767a1.55 1.55 0 01-.273-.708 1.103 1.103 0 00-.247-.594.735.735 0 00-.57-.168h-.138a1.456 1.456 0 01-1.197.495.99.99 0 01-.6-.896zM9.431 4.425a.594.594 0 00-.321-.257 5.37 5.37 0 01-.708-.292 1.485 1.485 0 00-.807-.282.99.99 0 00-.311.054 1.53 1.53 0 00-.565.396l-.118.104-.322.238a.322.322 0 00-.129.38.92.92 0 00.46.495c.144.102.282.213.411.332a.807.807 0 00.495.203c.237.012.471-.049.673-.173.164-.113.338-.211.52-.292a1.104 1.104 0 00.712-.564.381.381 0 00.01-.342zM3.691 11.037a.583.583 0 00-.44.222c-.149.159-.278.376-.386.495-.204.164-.43.296-.673.391a.698.698 0 00-.46.351 1.05 1.05 0 000 .629c.059.246.059.502 0 .747a1.083 1.083 0 00-.08.827c.074.143.233.217.495.272.654.035 1.3.173 1.91.41.485.281 1.05.39 1.604.307a.886.886 0 00.752-.87 1.777 1.777 0 00-.495-1.055 7.551 7.551 0 01-.797-1.093 6.687 6.687 0 00-.633-1.099 1.084 1.084 0 00-.683-.495H3.7l-.01-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M9.144 4.514v.129a.767.767 0 00-.262.104l-.386.232a2.103 2.103 0 01-.99.332 1.38 1.38 0 01-.856-.327c-.104-.084-.188-.163-.252-.222l-.074-.07h-.025V4.57a.148.148 0 01.089.04l.114.034c.064.06.143.138.242.218.219.186.495.293.782.302a1.98 1.98 0 00.935-.322l.367-.198a.787.787 0 01.316-.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5B",
    d: "M7.779 4.064s-.05 0 0-.094.247-.04.386.198a.495.495 0 00-.386-.104zM7.328 4.054a.06.06 0 00.05-.084c-.035-.104-.247-.04-.386.198a.386.386 0 01.336-.114z"
  }));
}

LinuxMulticolorFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
LinuxMulticolorFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = LinuxMulticolorFilled;
exports["default"] = _default;